
















































import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import GridContainer from '@/components/layout/GridContainer.vue';
import XsollaCopy from '@/components/common/XsollaCopy.vue';
import PortalIcon from '@/components/icons/PortalIcon.vue';

import LocaleMixin from '@/mixins/locale';
import SOCIAL_LINKS from '@/config/socialLinks';

@Component({
  components: {
    XsollaCopy,
    GridContainer,
    PortalIcon,
  },
})
export default class PageFooter extends mixins(LocaleMixin) {
  @Prop(Boolean) readonly light!: boolean;

  @Prop(Boolean) readonly withXsolla!: boolean;

  get year() {
    return new Date().getFullYear();
  }

  get facebookUrl() {
    if (this.$appName === undefined) {
      return '';
    }
    return SOCIAL_LINKS[this.$appName]?.facebook;
  }

  get vkUrl() {
    if (this.$appName === undefined) {
      return '';
    }
    return SOCIAL_LINKS[this.$appName]?.vk;
  }

  get instagramUrl() {
    if (this.$appName === undefined) {
      return '';
    }
    return SOCIAL_LINKS[this.$appName]?.instagram;
  }

  get twitterUrl() {
    if (this.$appName === undefined) {
      return '';
    }
    return SOCIAL_LINKS[this.$appName]?.twitter;
  }

  get rootClasses() {
    const { root, light } = this.$style;

    return {
      [root]: true,
      [light]: this.light,
    };
  }
}
